import "core-js/modules/es.array.find";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.object.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import addPlayer from "./components/addPlayer.vue";
import { outstandingScoreLogList } from "@/api/gmToolNew/gmToolNew";
import { gmToolNew, gmToolNewPage } from "@/mixins/index";
import { mapActions } from 'vuex';
export default {
  name: "tianmojieying",
  mixins: [gmToolNew, gmToolNewPage],
  components: {
    addPlayer: addPlayer
  },
  data: function data() {
    return {
      tableData: [],
      paramsData: {
        uid: '',
        page: 1
      },
      date: [],
      playList: [{
        label: this.$t('increase'),
        value: 1
      }, {
        label: this.$t('deduct'),
        value: 2
      }],
      total: 0,
      exreqLoading: false
    };
  },
  created: function created() {// this.getList()
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    // ...mapActions('d2admin/user', [
    //   'usersList'
    // ]),
    getList: function getList(e) {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this.paramsData.page = e; // this.paramsData.start_time = this.date && this.date[0] ? Math.floor(this.date[0] / 1000) : '';
                // this.paramsData.end_time = this.date && this.date[1] ? Math.floor(this.date[1] / 1000) : '';

                _this.paramsData.start_time = _this.date && _this.date[0] ? _this.$times.timestampToTime(_this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.paramsData.end_time = _this.date && _this.date[1] ? _this.$times.timestampToTime(_this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
                _this.paramsData.type = 2;
                _this.reqLoading = true;
                outstandingScoreLogList(_this.paramsData).then(function (res) {
                  if (res.status == 200) {
                    _this.tableData = res.data.data;

                    _this.tableData.forEach(function (item) {
                      var foundData = _this.serverListYJ.find(function (b) {
                        return b.serverID == item.server_id;
                      });

                      item.server_name = foundData ? foundData.serverName : '/';
                    });

                    _this.total = res.data.total;
                  }
                }).finally(function () {
                  _this.reqLoading = false;
                });

              case 6:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    exportdata: function exportdata() {
      var _this2 = this;

      // this.paramsData.start_time = this.date && this.date[0] ? Math.floor(this.date[0] / 1000) : '';
      // this.paramsData.end_time = this.date && this.date[1] ? Math.floor(this.date[1] / 1000) : '';
      this.paramsData.start_time = this.date && this.date[0] ? this.$times.timestampToTime(this.date[0] / 1000, "YY-MM-DD hh:mm:ss") : '';
      this.paramsData.end_time = this.date && this.date[1] ? this.$times.timestampToTime(this.date[1] / 1000, "YY-MM-DD hh:mm:ss") : '';
      this.exreqLoading = true;
      outstandingScoreLogList(_objectSpread(_objectSpread({}, this.paramsData), {}, {
        pageSize: -1
      })).then(function (res) {
        if (res.status == 200) {
          var data = res.data.data;
          data.forEach(function (item) {
            var foundData = _this2.serverListYJ.find(function (b) {
              return b.serverID == item.server_id;
            });

            item.server_name = foundData ? foundData.serverName : '/';
            item.score_type = item.score_type == 1 ? _this2.$t('increase') : _this2.$t('deduct');
            item.damage_type = item.damage_type == 1 ? _this2.$t('increase') : _this2.$t('deduct');
          });
          var columns = [{
            label: _this2.$t('serverName'),
            prop: 'server_name'
          }, {
            label: _this2.$t('roleId'),
            prop: 'role_id'
          }, {
            label: _this2.$t('roleName'),
            prop: 'role_name'
          }, {
            label: _this2.$t('score'),
            prop: 'score'
          }, {
            label: _this2.$t('damage'),
            prop: 'damage'
          }, {
            label: _this2.$t('scoreOperationType'),
            prop: 'score_type'
          }, {
            label: _this2.$t('damageOperationType'),
            prop: 'damage_type'
          }, {
            label: _this2.$t('operatorUser'),
            prop: 'admin_name'
          }, {
            label: _this2.$t('time'),
            prop: 'op_time'
          }];

          _this2.$export.excel({
            columns: columns,
            data: data,
            title: _this2.$route.meta.title
          });
        }
      }).finally(function () {
        _this2.exreqLoading = false;
      });
    }
  }
};